var _rect, _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationPain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.54 51.5522C197.565 59.119 210.884 79.8485 211.486 100.282C212.052 120.751 199.897 140.881 186.99 158.228C174.121 175.536 160.503 190.024 143.755 196.387C126.974 202.746 107.033 200.98 92.734 192.098C78.4736 183.249 69.8945 167.258 60.3726 151.453C50.853 135.689 40.4691 120.073 38.3996 101.447C36.2918 82.8586 42.5387 61.1863 56.8754 52.9821C71.2121 44.7778 93.5982 50.0483 116.175 49.8597C138.752 49.6712 161.479 44.0281 179.54 51.5522Z",
    fill: "#E7EEF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4063 105.189C84.5522 108.131 84.4063 219.602 84.4063 219.602H92.1841L104.081 146.347C104.231 143.972 106.4 117.716 106.4 117.716L92.7071 103.651L84.4063 105.189Z",
    fill: "#56CAD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.841 104.394C115.841 104.394 124.752 161.409 124.752 163.729C124.752 166.05 110.162 218.648 110.162 218.648H102.676L109.044 158.006L87.2099 106.706",
    fill: "#74D5DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7565 82.8249C78.3502 83.4152 75.7935 89.3793 75.9866 91.7272C76.2828 95.3187 78.7475 97.3053 82.963 99.4848C84.1751 99.4848 85.468 85.4848 85.468 85.4848L81.6768 82.8249L78.7565 82.8249Z",
    fill: "#FFD8C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2099 67.2491C81.5331 71.6352 76.7183 80.2682 77.6543 81.8575C78.1033 82.6004 80.4422 83.9248 83.1134 85.1279",
    fill: "#8D6AFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.75,
    cy: 41.5147,
    rx: 12.5993,
    ry: 9.92593,
    transform: "rotate(-76.27 100.75 41.5147)",
    fill: "#FFD8C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.123 56.3603C112.75 56.3603 117.908 101.635 115.836 104.396C113.01 108.163 92.7901 111.195 84.4108 105.191C81.1874 102.89 80.6981 56.3603 100.123 56.3603Z",
    fill: "#9E80FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4063 219.602V224.951H102.676V221.929L92.1841 219.602",
    fill: "#31403B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.676 218.648V224.951H121.809V222.499L110.171 218.648",
    fill: "#31403B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.031 79.9293C118.386 80.3064 121.455 84.7845 121.883 85.7408C122.739 85.0112 150.202 61.9854 150.653 61.6734C151.104 61.3614 151.886 61.3883 152.191 61.5949C152.703 61.9301 152.883 62.5956 152.611 63.1437C152.368 63.5926 148.954 66.596 148.954 66.596C149.232 66.9439 150.658 70.5578 148.833 72.2548C147.591 73.4108 146.184 73.7946 144.831 73.0786C143.933 74.0505 122.469 97.7699 118.725 97.7699C116.992 97.7699 111.048 91.6712 108.368 87.0763",
    fill: "#FFD8C1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.055 69.8238C99.055 77.2312 104.891 87.5567 106.911 87.5567C108.932 87.5567 119.033 80.1493 119.033 78.3536C119.033 76.5578 111.176 63.3143 104.442 63.3143C101.749 63.3143 99.055 66.2323 99.055 69.8238Z",
    fill: "#B098FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3816 40.1964C102.251 40.2256 109.277 32.6341 109.277 32.3401C109.277 31.6667 108.083 28.1089 101.154 28.1089C96.2043 28.1089 88.4175 31.5747 88.4175 42.9574C88.4175 48.8182 86.1257 55.0786 86.1257 57.9069C86.1257 62.2054 89.5892 64.9147 95.0595 64.9147C97.7015 64.9147 101.675 63.6128 101.675 61.4759C101.675 58.3513 104.88 48.1987 98.7565 45.9877",
    fill: "#DF684E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4546 45.6779C99.0876 45.9163 98.6598 46.0441 98.2222 46.046C96.8238 46.046 95.6902 44.7351 95.6902 43.1167C95.6902 41.4983 96.8238 40.1987 98.2222 40.1987C98.484 40.1985 98.7438 40.244 98.9899 40.3334",
    fill: "#FFD8C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 157.488,
    y: 25,
    width: 44.4467,
    height: 32.8575,
    fill: "#145E7F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 179.71,
    cy: 86.1717,
    r: 18.9226,
    fill: "#145E7F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationPain);
export default __webpack_public_path__ + "static/media/IllustrationPain.fcd7bbaea899b31980732a000d7d8074.svg";
export { ForwardRef as ReactComponent };